import { uniq } from 'lodash';

/**
 *
 * @param {WorkOrder[]} workOrders
 */
exports.processWorkOrders = ({ workOrders }) => {
    const opportunities = workOrders.filter(wo => wo.adminPlatform === 'salesforce');
    const opportunityCount = opportunities.length;

    if (!opportunities || !opportunityCount) {
        return {};
    }

    const entityOpportunityDetails = {
        region: [],
        accountName: [],
        agencyName: [],
        jobType: [],
        jobSegment: []
    };

    opportunities.reduce(exports.opprtunityDetailsReducer, entityOpportunityDetails);
    const sanitizedOpportunityDetails = exports.sanitizeOpportunityDetails({ entityOpportunityDetails });

    sanitizedOpportunityDetails.opportunityCount = opportunityCount;
    return sanitizedOpportunityDetails;
};

exports.opprtunityDetailsReducer = (acc, cur) => {
    if (cur.opportunityDetails) {
        acc.region.push(cur.opportunityDetails.region);
        acc.accountName.push(cur.opportunityDetails.accountName);
        acc.agencyName.push(cur.opportunityDetails.agencyName);
        acc.jobType.push(cur.opportunityDetails.jobType);
        acc.jobSegment.push(cur.opportunityDetails.jobSegment);
    }

    return acc;
};

exports.sanitizeOpportunityDetails = ({ entityOpportunityDetails }) => {
    for (const [key, val] of Object.entries(entityOpportunityDetails)) {
        entityOpportunityDetails[key] = uniq(val).filter(e => !!e);
    }

    return entityOpportunityDetails;
};



// WEBPACK FOOTER //
// ./src/helpers/tracking.js